/* Thème ZNP04 : onglets, sliders de visuels carrés, visionneuse, galerie produit, barre d'achat mobile */
(() => {
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];

  // Sliders : flèches qui défilent d'un visuel, désactivées en bout de piste
  function initSlider(sl) {
    const track = sl.querySelector('.znp-track');
    const prev = sl.querySelector('[data-prev]'), next = sl.querySelector('[data-next]');
    if (!track) return;
    const step = () => {
      const s = track.querySelector('.znp-slide');
      return s ? s.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 0) : track.clientWidth;
    };
    const update = () => {
      const max = track.scrollWidth - track.clientWidth - 2;
      sl.toggleAttribute('data-static', max <= 0);
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max;
      sl.dispatchEvent(new CustomEvent('znp:scroll', { detail: Math.round(track.scrollLeft / step()) }));
    };
    prev && prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
    next && next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
    track.addEventListener('scroll', () => requestAnimationFrame(update), { passive: true });
    window.addEventListener('resize', update);
    sl.znpGo = i => track.scrollTo({ left: i * step(), behavior: 'smooth' });
    sl.znpUpdate = update;
    update();
  }
  $$('[data-slider]').forEach(initSlider);

  // Onglets (fonctions, destinations)
  $$('[role=tablist]').forEach(list => {
    const tabs = $$('[role=tab]', list);
    const select = tab => {
      tabs.forEach(t => {
        const on = t === tab;
        t.setAttribute('aria-selected', on);
        t.tabIndex = on ? 0 : -1;
        const p = document.getElementById(t.getAttribute('aria-controls'));
        if (p) p.hidden = !on;
      });
      const panel = document.getElementById(tab.getAttribute('aria-controls'));
      const sl = panel && panel.querySelector('[data-slider]');
      if (sl) { sl.querySelector('.znp-track').scrollLeft = 0; sl.znpUpdate && sl.znpUpdate(); }
      if (panel) panel.dispatchEvent(new CustomEvent('znp:panel', { bubbles: true }));
      tab.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
    };
    tabs.forEach((t, i) => {
      t.tabIndex = t.getAttribute('aria-selected') === 'true' ? 0 : -1;
      t.addEventListener('click', () => select(t));
      t.addEventListener('keydown', e => {
        const d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (!d) return;
        const n = tabs[(i + d + tabs.length) % tabs.length];
        n.focus(); select(n);
      });
    });
  });

  // Visionneuse plein écran des visuels
  const lb = document.getElementById('znp-lb');
  if (lb && lb.showModal) {
    const img = lb.insertBefore(Object.assign(new Image(1080, 1080), { alt: '' }), lb.firstChild), num = lb.querySelector('.znp-lb__n');
    let group = [], idx = 0;
    const show = i => {
      idx = (i + group.length) % group.length;
      const b = group[idx];
      img.src = b.dataset.src;
      img.alt = b.querySelector('img') ? b.querySelector('img').alt : '';
      num.textContent = `${idx + 1} / ${group.length}`;
    };
    document.addEventListener('click', e => {
      const b = e.target.closest('[data-zoom]');
      if (!b) return;
      group = $$(`[data-zoom][data-group="${b.dataset.group}"]`);
      show(group.indexOf(b));
      lb.showModal();
    });
    lb.querySelector('[data-close]').addEventListener('click', () => lb.close());
    lb.querySelector('[data-lb-prev]').addEventListener('click', () => show(idx - 1));
    lb.querySelector('[data-lb-next]').addEventListener('click', () => show(idx + 1));
    lb.addEventListener('click', e => { if (e.target === lb) lb.close(); });
    lb.addEventListener('keydown', e => {
      if (e.key === 'ArrowRight') show(idx + 1);
      if (e.key === 'ArrowLeft') show(idx - 1);
    });
  }

  // Galerie produit : miniatures reliées au slider
  $$('[data-gallery]').forEach(g => {
    const thumbs = $$('[data-thumb]', g.parentElement);
    thumbs.forEach((t, i) => t.addEventListener('click', () => g.znpGo && g.znpGo(i)));
    g.addEventListener('znp:scroll', e => thumbs.forEach((t, i) => t.setAttribute('aria-current', i === e.detail)));
  });

  // Vidéos créateurs (hébergées par Shopify) : lecture dans la carte au clic, une seule vidéo à la fois
  // Une vidéo arrêtée revient à son image d'aperçu et coupe son téléchargement : sinon chaque vidéo déjà ouverte
  // garde une connexion, et au-delà de six le navigateur fait attendre les suivantes (elles ne se chargent plus)
  const sources = v => [v, ...v.querySelectorAll('source')];
  const unload = v => {
    v.pause();
    const box = v.closest('[data-vid]');
    if (box) box.classList.remove('is-playing');
    if (v.dataset.unloaded || (v.readyState === 0 && v.networkState !== 2)) return;
    sources(v).forEach(el => { if (el.hasAttribute('src')) { el.dataset.src = el.getAttribute('src'); el.removeAttribute('src'); } });
    v.dataset.unloaded = '1';
    v.load();
  };
  const reload = v => {
    if (!v.dataset.unloaded) return;
    sources(v).forEach(el => { if (el.dataset.src) { el.setAttribute('src', el.dataset.src); delete el.dataset.src; } });
    delete v.dataset.unloaded;
    v.load();
  };
  document.addEventListener('click', e => {
    const b = e.target.closest('.znp-tt__play');
    const box = b && b.closest('[data-vid]');
    const v = box && box.querySelector('video');
    if (!v) return;
    reload(v);
    box.classList.add('is-playing');
    v.play().catch(() => {});
    v.focus({ preventScroll: true });
  });
  document.addEventListener('play', e => {
    if (!e.target.closest || !e.target.closest('[data-vid]')) return;
    $$('[data-vid] video').forEach(o => { if (o !== e.target) unload(o); });
  }, true);
  document.addEventListener('ended', e => {
    if (e.target.closest && e.target.closest('[data-vid]')) unload(e.target);
  }, true);

  // Écran « assistant IA » du boîtier : état (ecoute, pensee, parle) et texte qui s'écrit mot à mot puis défile
  // sur deux lignes, comme sur le vrai boîtier. progress : part du texte déjà affichée (0 à 1).
  window.znpIa = {
    set(ia, state, text = '', progress = 1) {
      if (!ia) return;
      if (ia.dataset.state !== state) ia.dataset.state = state;
      const p = ia.querySelector('[data-ia-text]');
      const words = text ? text.split(' ') : [];
      const shown = words.slice(0, Math.max(0, Math.ceil(words.length * Math.min(1, progress)))).join(' ');
      if (p.textContent !== shown) {
        p.textContent = shown;
        const win = p.parentElement.clientHeight;
        p.style.transform = 'translateY(' + -Math.max(0, p.offsetHeight - win) + 'px)';
      }
    }
  };

  // Écrans posés sur les photos du boîtier (lecteur de musique, assistant IA) : le repère de la photo, en px, est ramené
  // à la largeur affichée du boîtier. Le CSS le fait avec tan(atan2(100cqw, …)), que certains navigateurs Android
  // calculent faux (écran 30 % trop petit sur un Realme, 2026-10-24) : le script mesure le boîtier et pose l'échelle.
  const maps = $$('[data-map-w]');
  if (maps.length) {
    const fit = m => { const w = m.parentElement.clientWidth; if (w) m.style.transform = 'scale(' + (w / m.dataset.mapW).toFixed(5) + ')'; };
    maps.forEach(fit);
    if ('ResizeObserver' in window) {
      const ro = new ResizeObserver(es => es.forEach(e => maps.forEach(m => { if (m.parentElement === e.target) fit(m); })));
      maps.forEach(m => ro.observe(m.parentElement));
    } else window.addEventListener('resize', () => maps.forEach(fit));
  }

  // Police des écrans du boîtier (Noto Sans, 35 Ko) : chargée seulement quand un écran (lecteur, assistant IA) approche,
  // pour laisser passer d'abord la photo du haut de page
  const iaFont = $$('[data-font]');
  if (iaFont.length && 'FontFace' in window) {
    let fontAsked = false;
    const loadFont = () => {
      if (fontAsked) return; fontAsked = true;
      new FontFace('ZNP Noto Sans', `url(${iaFont[0].dataset.font}) format('woff2')`, { weight: '400 500', display: 'swap' })
        .load().then(f => document.fonts.add(f)).catch(() => { /* police de secours de l'écran */ });
    };
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver(es => { if (es.some(e => e.isIntersecting)) { loadFont(); io.disconnect(); } }, { rootMargin: '1500px 0px' });
      iaFont.forEach(b => io.observe(b));
    } else loadFont();
  }

  // Avis : « Voir plus » sur ordinateur
  $$('[data-avis-more]').forEach(b => b.addEventListener('click', () => {
    const sec = b.closest('[data-avis]');
    sec.classList.add('is-open');
    b.setAttribute('aria-expanded', 'true');
    const first = sec.querySelector('.znp-avis__card.is-more .znp-zoom, .znp-avis__card.is-more');
    if (first) first.focus({ preventScroll: true });
    if (window.ScrollTrigger) window.ScrollTrigger.refresh();
  }));

  // Carte des langues : survol, clic ou clavier sur un point = le pays et ses langues
  $$('[data-map]').forEach(map => {
    const frame = map.querySelector('.znp-map__frame'), tip = map.querySelector('.znp-map__tip');
    const pins = $$('.znp-map__pin', map);
    let cur = null;
    pins.forEach(p => p.style.setProperty('--d', (Math.random() * 2.6).toFixed(2) + 's'));
    const hide = () => {
      if (cur) { cur.classList.remove('is-on'); const c = map.querySelector(`path[data-iso="${cur.dataset.iso}"]`); if (c) c.classList.remove('hl'); }
      cur = null; tip.hidden = true;
    };
    const show = p => {
      if (cur === p) return; hide(); cur = p;
      p.classList.add('is-on');
      const c = map.querySelector(`path[data-iso="${p.dataset.iso}"]`); if (c) c.classList.add('hl');
      tip.querySelector('b').textContent = p.dataset.name;
      tip.querySelector('span').textContent = p.dataset.langs.split(' | ').join('\n');
      tip.hidden = false;
      const fr = frame.getBoundingClientRect(), pr = p.getBoundingClientRect();
      const x = Math.min(Math.max(pr.left + pr.width / 2 - fr.left, tip.offsetWidth / 2 + 4), fr.width - tip.offsetWidth / 2 - 4);
      const y = pr.top - fr.top;
      const below = y < tip.offsetHeight + 24;
      tip.style.left = x + 'px'; tip.style.top = (below ? y + pr.height + 4 : y) + 'px';
      tip.style.translate = below ? '-50% 12px' : '-50% calc(-100% - 6px)';
    };
    pins.forEach(p => {
      p.addEventListener('mouseenter', () => show(p));
      p.addEventListener('focus', () => show(p));
      p.addEventListener('click', e => { e.stopPropagation(); stop(); show(p); }); // au toucher, le survol simulé a déjà ouvert : on garde ouvert
    });
    map.addEventListener('mouseleave', hide);
    document.addEventListener('click', e => { if (!e.target.closest('.znp-map__pin')) hide(); });
    document.addEventListener('keydown', e => { if (e.key === 'Escape') hide(); });

    // Regroupement par langue (2026-10-24) : un bouton par langue ; ses pays s'allument et seuls ses points restent.
    // Les langues défilent seules tant que la carte est à l'écran, jusqu'au premier toucher du visiteur.
    const bar = map.querySelector('[data-map-langs]'), now = map.querySelector('[data-map-now]');
    let auto = null, stopped = false;
    function stop() { stopped = true; clearInterval(auto); auto = null; if (now) now.setAttribute('aria-live', 'polite'); }
    if (!bar || !now) return;
    const base = l => { const b = l.split(' · ')[0].replace(/\s*\(.*?\)/g, '').trim(); return /^(Chinois|Cantonais)/.test(b) ? 'Chinois' : b; };
    const NATIVE = { Arabe: 'العربية', Chinois: '中文' }; // écriture courte, comme dans le bandeau des langues
    const groups = new Map();
    pins.forEach(p => p.dataset.langs.split(' | ').forEach(l => {
      const k = base(l);
      if (!groups.has(k)) groups.set(k, { pins: [], native: NATIVE[k] || (l.split(' · ')[1] || k).trim() });
      const g = groups.get(k);
      if (!g.pins.includes(p)) g.pins.push(p);
    }));
    const keys = ['', ...bar.dataset.mapLangs.split(',').map(x => x.trim()).filter(k => groups.has(k))];
    if (keys.length < 2) return;
    const stats = $$('.znp-map__stats dt', map).map(d => d.textContent.trim());
    const chips = keys.map(k => {
      const c = document.createElement('button');
      c.type = 'button'; c.className = 'znp-map__lang'; c.dataset.lang = k;
      c.textContent = k || bar.dataset.all;
      c.setAttribute('aria-pressed', 'false');
      c.addEventListener('click', () => { stop(); select(k); });
      bar.appendChild(c);
      return c;
    });
    const lit = new Set(), allPaths = $$('.znp-map__svg path.on', map);
    const pathsOf = g => g.pins.flatMap(p => $$(`path[data-iso="${p.dataset.iso}"]`, map));
    function select(k) {
      hide();
      const g = groups.get(k);
      chips.forEach(c => c.setAttribute('aria-pressed', String(c.dataset.lang === k)));
      pins.forEach(p => { const on = !!g && g.pins.includes(p); p.classList.toggle('is-shown', on); p.tabIndex = on ? 0 : -1; });
      if (g) g.pins.forEach((p, i) => p.style.setProperty('--sd', (i * 0.04).toFixed(2) + 's'));
      const next = new Set(g ? pathsOf(g) : allPaths);
      lit.forEach(x => { if (!next.has(x)) { x.classList.remove('is-lang'); lit.delete(x); } });
      next.forEach(x => { x.classList.add('is-lang'); lit.add(x); });
      // légende : la langue dans son écriture, puis les pays
      const [big, small] = now.children;
      if (g) {
        const names = g.pins.map(p => p.dataset.name);
        big.textContent = g.native;
        small.textContent = names.length === 1 ? `${k} · ${names[0]}` : `${k} · ${names.length} pays : ${names.slice(0, 6).join(', ')}${names.length > 6 ? ` et ${names.length - 6} autres` : ''}`;
      } else {
        big.textContent = `${stats[0] || '165'} langues`;
        small.textContent = `dans ${stats[1] || '122'} pays`;
      }
      // le bouton choisi reste visible dans la rangée (défilement horizontal seulement, la page ne bouge pas)
      const c = chips[keys.indexOf(k)];
      if (bar.scrollWidth > bar.clientWidth) bar.scrollTo({ left: c.offsetLeft - (bar.clientWidth - c.offsetWidth) / 2, behavior: 'smooth' });
    }
    map.classList.add('is-grouped');
    bar.hidden = false; now.hidden = false;
    select('');
    // défilement automatique : seulement à l'écran, jamais si le visiteur réduit les animations
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
    let i = 0;
    const tick = () => { if (document.hidden) return; i = (i + 1) % keys.length; select(keys[i]); };
    new IntersectionObserver(([e]) => {
      if (e.isIntersecting && !stopped && !auto) auto = setInterval(tick, 2600);
      else if (!e.isIntersecting && auto) { clearInterval(auto); auto = null; }
    }, { threshold: 0.45 }).observe(frame);
  });

  // Offres (1 paire / lot de 2) : le prix affiché suit l'offre choisie
  $$('[data-offers]').forEach(f => f.addEventListener('change', e => {
    const price = e.target.dataset.price;
    if (!price) return;
    const box = f.closest('.znp-buy__info');
    const big = box && box.querySelector('[data-price] span');
    if (big) big.textContent = price;
    const sticky = document.querySelector('[data-sticky-price]');
    if (sticky) sticky.textContent = price;
    // Paiement PayPal : second lien pour le lot de 2 s'il existe, sinon une phrase guide le choix sur PayPal
    const pp = box && box.querySelector('[data-pp]');
    if (pp) {
      const two = +e.target.dataset.units >= 2;
      if (pp.dataset.ppTwo) pp.href = two ? pp.dataset.ppTwo : pp.dataset.ppOne;
      const note = box.querySelector('[data-pp-note]');
      if (note) note.hidden = !two;
    }
    // Prix constaté ailleurs : multiplié par le nombre de paires, et l'économie recalculée
    const cmp = box && box.querySelector('[data-cmp]');
    const units = +e.target.dataset.units, cents = +e.target.dataset.cents;
    if (cmp && units && cents) {
      const ref = +cmp.dataset.cmp * units;
      const eur = c => (c / 100).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' });
      cmp.querySelector('[data-cmp-ref]').textContent = eur(ref);
      cmp.querySelector('[data-cmp-save]').textContent = eur(ref - cents);
      cmp.hidden = ref <= cents;
      const alt = cmp.querySelector('[data-cmp2]');
      if (alt) alt.querySelector('[data-cmp2-ref]').textContent = eur(+alt.dataset.cmp2 * units);
    }
  }));

  // Black Friday : bandeau et badges retirés dès le lendemain du dernier jour (les pages Shopify peuvent être en cache)
  const today = new Date();
  const ymd = [today.getFullYear(), String(today.getMonth() + 1).padStart(2, '0'), String(today.getDate()).padStart(2, '0')].join('-');
  $$('[data-bf-end]').forEach(el => { if (ymd > el.dataset.bfEnd) el.remove(); });

  // Quantité +/-
  $$('[data-qty]').forEach(q => {
    const input = q.querySelector('input');
    q.addEventListener('click', e => {
      const d = e.target.closest('[data-d]');
      if (!d) return;
      input.value = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(d.dataset.d, 10));
    });
  });

  // Barre d'achat mobile : visible quand le bloc d'achat et le haut de page sont hors écran
  const bar = document.querySelector('[data-sticky]');
  const buys = $$('[data-buy]');
  const hero = document.querySelector('[data-scene], [data-intro]') || document.querySelector('.znp-hero') || document.querySelector('.znp-buy');
  if (bar && buys.length && 'IntersectionObserver' in window) {
    bar.hidden = false;
    const seen = new Map();
    const io = new IntersectionObserver(es => {
      es.forEach(e => seen.set(e.target, e.isIntersecting));
      bar.classList.toggle('is-on', ![...seen.values()].some(Boolean));
    });
    buys.forEach(b => io.observe(b));
    if (hero && !buys.includes(hero)) io.observe(hero);
  }

  // Promesses d'achat : une promesse à la fois, toutes les 3,2 s, en pause au survol ou au clavier
  const flips = $$('[data-flip]').filter(f => f.children.length > 1);
  if (flips.length) {
    const paused = new Set();
    flips.forEach(f => {
      ['mouseenter', 'focusin'].forEach(ev => f.addEventListener(ev, () => paused.add(f)));
      ['mouseleave', 'focusout'].forEach(ev => f.addEventListener(ev, () => paused.delete(f)));
    });
    setInterval(() => {
      if (document.hidden) return;
      flips.forEach(f => {
        if (paused.has(f)) return;
        const items = [...f.children];
        const cur = items.findIndex(el => el.classList.contains('is-on'));
        const next = items[(cur + 1) % items.length];
        items.forEach(el => el.classList.remove('is-out'));
        items[cur].classList.replace('is-on', 'is-out');
        items[cur].setAttribute('aria-hidden', 'true');
        next.classList.add('is-on');
        next.removeAttribute('aria-hidden');
      });
    }, 3200);
  }

  // Suivi de commande : le numéro saisi ouvre la page de suivi du transporteur dans un nouvel onglet
  $$('[data-suivi]').forEach(f => f.addEventListener('submit', e => {
    e.preventDefault();
    const input = f.elements.numero, err = f.querySelector('.znp-suivi__err');
    const n = input.value.replace(/\s+/g, '').toUpperCase();
    if (n.length < 6) { err.hidden = false; input.setAttribute('aria-invalid', 'true'); input.focus(); return; }
    err.hidden = true; input.removeAttribute('aria-invalid');
    window.open(f.dataset.suivi.replace('{numero}', encodeURIComponent(n)), '_blank', 'noopener');
  }));

  // Menu déroulant de l'en-tête : ouvert ou fermé au toucher ; se ferme sur un lien, au toucher à côté ou avec Échap
  const menu = document.querySelector('[data-menu]');
  if (menu) {
    const btn = menu.querySelector('.znp-menu__btn'), panel = menu.querySelector('.znp-menu__panel');
    const set = open => { btn.setAttribute('aria-expanded', String(open)); panel.hidden = !open; };
    btn.addEventListener('click', () => set(panel.hidden));
    panel.addEventListener('click', e => { if (e.target.closest('a, button')) set(false); });
    document.addEventListener('click', e => { if (!panel.hidden && !menu.contains(e.target)) set(false); });
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && !panel.hidden) { set(false); btn.focus(); } });
  }

  // WhatsApp : le bouton flottant prend le relais dès que le bouton vert du header sort de l'écran
  const waFloat = document.querySelector('[data-wa-float]');
  const waMenu = document.getElementById('znp-wa-menu');
  if (waFloat && waMenu) {
    const anchor = document.querySelector('[data-wa-anchor]');
    if (anchor && 'IntersectionObserver' in window) {
      new IntersectionObserver(([e]) => waFloat.classList.toggle('is-on', !e.isIntersecting)).observe(anchor);
    } else waFloat.classList.add('is-on');

    // Navigateurs sans l'attribut « popover » : ouverture et fermeture à la main
    if (!('popover' in HTMLElement.prototype)) {
      document.addEventListener('click', e => {
        const t = e.target.closest('[popovertarget="znp-wa-menu"]');
        if (t) waMenu.classList.toggle('is-open', t.getAttribute('popovertargetaction') !== 'hide' && !waMenu.classList.contains('is-open'));
        else if (!e.target.closest('#znp-wa-menu')) waMenu.classList.remove('is-open');
      });
    }
    const close = () => (waMenu.hidePopover ? waMenu.matches(':popover-open') && waMenu.hidePopover() : waMenu.classList.remove('is-open'));
    waMenu.addEventListener('click', e => {
      const a = e.target.closest('[data-wa-motif]');
      if (!a) return;
      if (a.hasAttribute('data-wa-missing')) {
        e.preventDefault();
        alert('Numéro WhatsApp à renseigner : Personnaliser → Paramètres du thème → WhatsApp.');
        return;
      }
      // Compte les demandes par motif dans Shopify (Paramètres → Événements clients), pour savoir ce qui revient le plus
      try { window.Shopify && Shopify.analytics && Shopify.analytics.publish && Shopify.analytics.publish('znp_whatsapp', { motif: a.dataset.waMotif, page: location.pathname }); } catch (err) { /* sans effet sur le lien */ }
      setTimeout(close, 300);
    });
  }
})();
